import { LocationType } from "./Enums";
import { ScheduleParameters } from "./ScheduleParameters";

export class MoveSplitDispatchParameters {
	scheduleId: number = 0;
	dispatchId: number = 0;
    scheduleParameters: ScheduleParameters = new ScheduleParameters();
    planPeriod: string = '';
	periodStartDate: string = '';
	periodEndDate: string = '';
	locCode: string = '';
	locationType: LocationType = LocationType.Origin;
}

 